import moment from 'moment-timezone';
import { isDevEnvironment } from './helpers';

// const colorMap: Record<string, string> = {
//   debug: isDev ? '\x1b[34m' : '',
//   info: isDev ? '\x1b[32m' : '',
//   warn: isDev ? '\x1b[33m' : '',
//   error: isDev ? '\x1b[31m' : '',
// };

function log(level: string, message: string) {
  if (!isDevEnvironment()) return;

  const now = moment().tz('America/Los_Angeles').format('MM/DD HH:mm:ss');
  // const colorCode = colorMap[level] || '';
  // const resetCode = isDev ? '\x1b[0m' : '';
  // const formattedMessage = `[${now} PST] ${colorCode}${level.toUpperCase()}${resetCode}: ${message}`;
  const formattedMessage = `[${now} PST] ${level.toUpperCase()}: ${message}`;

  switch (level) {
    case 'debug':
      console.info(formattedMessage);
      break;
    case 'info':
      console.info(formattedMessage);
      break;
    case 'warn':
      console.info(formattedMessage);
      break;
    case 'error':
      console.info(formattedMessage);
      break;
    default:
  }
}

export const debug = async (message: string) => {
  log('debug', message);
};

export const info = async (message: string) => {
  log('info', message);
};

export const warn = async (message: string) => {
  log('warn', message);
};

export const error = async (message: string) => {
  log('error', message);
};
